export { default as Badge } from './Badge';
export { default as BadgeWTip } from './BadgeWTip';
export { default as DeletableBadge } from './DeletableBadge';
export { default as BadgeWButton } from './BadgeWButton';

export type { BadgeProps } from './Badge';

export { BadgePropsSize, BadgePropsType } from './Badge';
